import { useMemo } from "react";
import { usePagination, useSearch, useSorting } from "@/hooks";
import { GetTransferTypesParams } from "@/redux/apis/config/trip/transferTypes";

export const useGetTransferTypesParams = () => {
  const { page, pageSize } = usePagination("config-transfer-types", 25);
  const { sorting, setSorting, sortKey, direction } = useSorting();
  const [search, setSearch] = useSearch();

  const params: GetTransferTypesParams = useMemo(
    () => ({
      page,
      page_size: pageSize,
      sort: sortKey,
      direction,
      search,
    }),
    [page, pageSize, sortKey, direction, search]
  );

  return {
    params,
    sorting,
    setSorting,
    sortKey,
    direction,
    search,
    setSearch,
  };
};
